import React from "react";
import { useAdminAuth } from "../auth";

export default function Topbar() {
  const { admin, logout } = useAdminAuth();

  return (
    <div className="flex items-center justify-between gap-3">
      <div>
        <div className="text-white font-semibold text-xl">Admin Panel</div>
        <div className="text-white/60 text-sm">
          Manage inventory, images, and descriptions.
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden sm:block text-right">
          <div className="text-white text-sm font-medium">{admin?.username || "Admin"}</div>
          <div className="text-white/60 text-xs">Authenticated</div>
        </div>

        <button
          onClick={logout}
          className="rounded-2xl px-4 py-2 bg-white/10 border border-white/10 text-white hover:bg-white/15 transition"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
